import React from 'react';
import clsx from 'clsx';
import { CMRItemResponse, UpdateCmrCustomDataV2ManipulationUnitRequestInDTO } from '@api/ringil-api.v2.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CMRTextFieldBlock from '@components/CMR/CMRTextFieldBlock.tsx';
import CMRNumberFieldBlock from '@components/CMR/CMRNumberFieldBlock.tsx';

interface CMRFieldBlockProps {
  value?: UpdateCmrCustomDataV2ManipulationUnitRequestInDTO;
  originalValue?: CMRItemResponse;
  onChange?: (val: UpdateCmrCustomDataV2ManipulationUnitRequestInDTO) => void;
}

const CMRManipulationUnit: React.FC<CMRFieldBlockProps> = ({
                                                             value,
                                                             originalValue,
                                                             onChange,
                                                           }) => {

  const { tr } = useTranslationLgs();

  return (
    <div
      className={clsx(
        'flex flex-col w-full items-start',
      )}>
      <div className="flex flex-row w-full gap-2.5">
        <CMRTextFieldBlock
          indexLabel={6}
          label={tr('CMREditForm.mpSignoNumberLabel', 'Arks and nos')}
          sublabel={tr('CMREditForm.mpSignoNumberSubLabel', 'Arks and nos')}
          value={value.mpSignoNumber?.value}
          originalValue={originalValue?.signoNumber}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpSignoNumber: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
        <CMRNumberFieldBlock
          indexLabel={7}
          label={tr('CMREditForm.mpCountLabel', 'Number of packages')}
          sublabel={tr('CMREditForm.mpCountSubLabel', 'Number of packages')}
          value={value.mpCount?.value}
          originalValue={originalValue?.count}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpCount: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
        <CMRTextFieldBlock
          indexLabel={8}
          label={tr('CMREditForm.mpPackagingNameLabel', 'Method of packaging')}
          sublabel={tr('CMREditForm.mpPackagingNameSubLabel', 'Method of packaging')}
          value={value.mpPackagingName?.value}
          originalValue={originalValue?.packagingName}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpPackagingName: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
      </div>
      <div className="flex flex-row w-full gap-2.5">
        <CMRTextFieldBlock
          indexLabel={9}
          label={tr('CMREditForm.mpNameLabel', 'Nature of the goods')}
          sublabel={tr('CMREditForm.mpNameSubLabel', 'Nature of the goods')}
          value={value.mpName?.value}
          originalValue={originalValue?.name}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpName: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
        <CMRTextFieldBlock
          indexLabel={10}
          label={tr('CMREditForm.mpStatisticsNumberLabel', 'Statistical number')}
          sublabel={tr('CMREditForm.mpStatisticsNumberSubLabel', 'Statistical number')}
          value={value.mpStatisticsNumber?.value}
          originalValue={originalValue?.statisticsNumber}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpStatisticsNumber: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
        <CMRNumberFieldBlock
          indexLabel={11}
          label={tr('CMREditForm.mpCompleteWeightLabel', 'Gross weight in kg')}
          sublabel={tr('CMREditForm.mpCompleteWeightSubLabel', 'Gross weight in kg')}
          value={value.mpCompleteWeight?.value}
          originalValue={originalValue?.completeWeight}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpCompleteWeight: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
        <CMRNumberFieldBlock
          indexLabel={12}
          label={tr('CMREditForm.mpVolumeLabel', 'Volume in m³')}
          sublabel={tr('CMREditForm.mpVolumeSubLabel', 'Volume in m³')}
          value={value.mpVolume?.value}
          originalValue={originalValue?.volume}
          onChange={(inputValue) => {
            if (!onChange) return;
            onChange({
              ...(value ?? {}),
              mpVolume: { value: inputValue },
            } as UpdateCmrCustomDataV2ManipulationUnitRequestInDTO);
          }}
          borders={false}
        />
      </div>
    </div>
  );
};

export default CMRManipulationUnit;